import React from 'react';
import './HoneycombLogo.css';

const HoneycombLogo = ({ size = 40 }) => {
    // Hexagon helper function
    const createHexagon = (cx, cy, radius) => {
        const points = [];
        for (let i = 0; i < 6; i++) {
            const angle = (Math.PI / 3) * i;
            const x = cx + radius * Math.cos(angle);
            const y = cy + radius * Math.sin(angle);
            points.push(`${x},${y}`);
        }
        return points.join(' ');
    };

    const hexRadius = 10;
    const hexWidth = hexRadius * 2 * Math.sin(Math.PI / 3);

    // Create 7 hexagon cluster - proper spacing
    const honeycombs = [
        // Center hexagon
        { x: 50, y: 50 },
        // Surrounding hexagons (proper spacing for no overlap)
        { x: 50, y: 50 - hexWidth },
        { x: 50 + hexRadius * 1.5, y: 50 - hexWidth / 2 },
        { x: 50 + hexRadius * 1.5, y: 50 + hexWidth / 2 },
        { x: 50, y: 50 + hexWidth },
        { x: 50 - hexRadius * 1.5, y: 50 + hexWidth / 2 },
        { x: 50 - hexRadius * 1.5, y: 50 - hexWidth / 2 },
    ];

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            className="honeycomb-logo"
        >
            {/* Honeycomb cells - outline only */}
            <g className="honeycomb-cells">
                {honeycombs.map((hex, i) => (
                    <polygon
                        key={i}
                        points={createHexagon(hex.x, hex.y, hexRadius)}
                        fill="none"
                        stroke="#FFD700"
                        strokeWidth="2"
                        strokeLinejoin="round"
                        className={`hex hex-${i}`}
                    />
                ))}
            </g>

            {/* Optional: Add bee elements (simplified) */}
            <g className="bee-element">
                {/* Bee body */}
                <ellipse cx="50" cy="50" rx="3" ry="5" fill="#FFD700" />
                
                {/* Bee stripes */}
                <line x1="48" y1="48" x2="52" y2="48" stroke="#000" strokeWidth="0.8" />
                <line x1="48" y1="52" x2="52" y2="52" stroke="#000" strokeWidth="0.8" />
            </g>
        </svg>
    );
};

export default HoneycombLogo;
